<div *ngIf="labelData?.partner === 'homie'; else elseBlock">
  <div
    *ngIf="labelData?.title"
    class="benefit-ticket border-r10 d-flex label-container"
    [ngClass]="labelData?.ticketClass"
    (click)="upgradeMembership()"
  >
    <div class="cashback-icon pad10">
      <ion-img [src]="labelData?.icon"></ion-img>
    </div>
    <div class="label-content pad10">
      <div class="chip-container" *ngIf="labelData?.chipTag">
        <ion-chip class="secondary-chip ion-no-margin fs-2 font500">
          {{ labelData?.chipTag }}
        </ion-chip>
      </div>
      <div>
        <h2
          class="mart5 font600 l-spacing0 title"
          [ngClass]="labelData?.fontClass"
          *ngIf="labelData?.title"
        >
          {{ labelData?.title }}
        </h2>
        <p
          class="marb5 fs-3 font400 titleP title"
          *ngIf="labelData?.description"
        >
          {{ labelData?.description }}
        </p>
      </div>
      <div class="small-icon" *ngIf="labelData?.isLocked">
        <ion-img [src]="labelData?.smallIcon"></ion-img>
      </div>
    </div>
  </div>
</div>
<ng-template #elseBlock>
  <div
    *ngIf="labelData?.title"
    class="benefit-ticket border-r10 ticket-label pad-hor-10"
    [ngClass]="labelData?.ticketClass"
  >
    <div
      class="discount-box pad10"
      *ngIf="labelData?.ticketClass.includes('ticket-dark')"
    >
      <custom-icon
        [iconName]="'DISCOUNT'"
        [width]="24"
        [height]="24"
        colorClass="tertiary-icon-color"
      ></custom-icon>
      <ion-label class="tertiary-icon-color fs-4 font600" *ngIf="labelData?.offerTagDiscount">{{labelData?.offerTagDiscount}}</ion-label>
      
    </div>
    <div class="pad10 details">
      <div class="chip-container" *ngIf="labelData?.chipTag">
        <ion-chip class="secondary-chip ion-no-margin fs-2 font500">
          {{ labelData?.chipTag }}
        </ion-chip>
      </div>

      <h2
        class="mart5 marr10 font600 l-spacing0 title"
        [ngClass]="labelData?.fontClass"
        *ngIf="labelData?.title"
      >
        {{ labelData?.title }}
      </h2>
      <p class="marb5 fs-3 font400 titleP title" *ngIf="labelData?.description">
        {{ labelData?.description }}
      </p>
    </div>
  </div>
</ng-template>
<div
  *ngIf="labelData?.displaySimpleLabel"
  class="d-block ion-text-center mar8 border-r10 grey-text pending_container"
  [ngClass]="{
    'light-secondary-sec': labelData?.lightSecondarySec,
    'secondary-sec': labelData?.secondarySec
  }"
>
  <ion-label class="fs-2 font500">
    {{ labelData?.simpleLabelTitle | translate }}
  </ion-label>
  <ion-text class="d-block fs-3 font600">
    {{ labelData?.simpleLabelSubTitle }}
  </ion-text>
</div>
